import { render, staticRenderFns } from "./StaffFormsModal.vue?vue&type=template&id=efe44a18"
import script from "./StaffFormsModal.vue?vue&type=script&lang=js"
export * from "./StaffFormsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports